module.exports = __webpack_public_path__ + "resources/img/bg-career-bottom@2x.1742e2f5.jpg";